import { IoGridOutline, IoListOutline } from "react-icons/io5";
import { ViewMode } from "../function/useViewMode";
import styles from "../styles/modules/ViewToggle.module.css";

interface ViewToggleProps {
  mode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

function ViewToggle({ mode, onChange }: ViewToggleProps) {
  return (
    <div className={styles["toggle"]} role="group" aria-label="表示切替">
      <button
        type="button"
        className={mode === "card" ? styles["active"] : ""}
        onClick={() => onChange("card")}
        title="カード表示"
        aria-pressed={mode === "card"}
      >
        <IoGridOutline />
      </button>
      <button
        type="button"
        className={mode === "list" ? styles["active"] : ""}
        onClick={() => onChange("list")}
        title="リスト表示"
        aria-pressed={mode === "list"}
      >
        <IoListOutline />
      </button>
    </div>
  );
}

export default ViewToggle;
